import ProgressBar from 'progressbar.js'
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Context } from '../../..'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { priceToUserString } from '../../../http/basketApi'
import { getLoyaltyInfo } from '../../../http/userAPI'
import Spiner from '../../../pages/administrator/spiner/Spiner'
import { getLevelProgress } from '../../../utils/getLevelProgress'
import { ProgressDesktop } from './Progress/Desktop'
import { ProgressMobile } from './Progress/mobile'
import { ProgressTablet } from './Progress/Tablet'
import './UserBonuses.css'

const UserBonuses = () => {
	const isTablet = useMediaQuery('(max-width: 834px)')
	const isMobile = useMediaQuery('(max-width: 576px)')
	const [showPreloader, setShowPreloader] = useState(false)
	const [collapsed, setCollapsed] = useState(false)
	const [activePath, setActivePath] = useState(1)
	const [totalOrders, setTotalOrders] = useState(0)
	const [history, setHistory] = useState([])
	const [available, setAvailable] = useState(0)
	const [blocked, setBlocked] = useState(0)
	const [level, setLevel] = useState(1)

	const { user } = useContext(Context)

	const handleHistoryMoreClick = useCallback(() => {
		setCollapsed((prevState) => !prevState)
	}, [collapsed])

	const bonusesHistory = useMemo(() => {
		if (collapsed) {
			return history
		}
		return history.slice(0, 4)
	}, [collapsed, history])

	const statusSumm = [50000, 150000, 300000]

	useEffect(() => {
		setShowPreloader(true)

		getLoyaltyInfo(user.user.id, 1).then((response) => {
			let customLevel = response.customLevel
			let activeLevel = response.activeLevel
			let totalOrders = response.totalCashOrders

			setLevel(customLevel)

			if (customLevel > 0) {
				if (customLevel == 2) {
					if (totalOrders < statusSumm[0]) {
						setTotalOrders(statusSumm[0])
					} else {
						setTotalOrders(totalOrders)
					}
				}
				if (customLevel == 3) {
					if (totalOrders < statusSumm[1]) {
						setTotalOrders(statusSumm[1])
					} else {
						setTotalOrders(totalOrders)
					}
				}
				if (customLevel == 4) {
					if (totalOrders < statusSumm[2]) {
						setTotalOrders(statusSumm[2])
					} else {
						setTotalOrders(totalOrders)
					}
				}
			} else {
				setLevel(activeLevel)
				setTotalOrders(totalOrders)
			}

			if (response.history?.length) {
				setHistory(response.history)
			}
			if (response.balance?.available) {
				setAvailable(response.balance.available)
			}
			if (response.balance?.blocked) {
				setBlocked(response.balance.blocked)
			}

			setShowPreloader(false)
		})
	}, [])

	const draftBonusPaths = () => {
		if (showPreloader) return

		const paths = {
			1: document.querySelectorAll('#path1'),
			2: document.querySelectorAll('#path2'),
			3: document.querySelectorAll('#path3'),
			4: document.querySelectorAll('#path4'),
		}

		const levels = [{ min: 0, max: 50000 }, { min: 50000, max: 150000 }, { min: 150000, max: 300000 }, { min: 300000 }]

		let activeLevel = 1

		levels.forEach((level, index) => {
			const levelNumber = index + 1
			const progress =
				level.max !== undefined ? getLevelProgress(totalOrders, level.min, level.max) : totalOrders >= level.min ? 1 : 0

			if (progress > 0 && progress < 1) {
				activeLevel = levelNumber
			}

			if (progress == 1) {
				activeLevel = 4
			}

			paths[levelNumber].forEach((path) => {
				const bar = new ProgressBar.Path(path)
				bar.set(progress)
			})
		})

		setActivePath(activeLevel)
	}

	useEffect(draftBonusPaths, [totalOrders, showPreloader])

	useEffect(() => {
		window.addEventListener('resize', draftBonusPaths)

		return () => {
			window.removeEventListener('resize', draftBonusPaths)
		}
	}, [])

	return (
		<>
			{showPreloader ? (
				<Spiner />
			) : (
				<div className='user-bonuses'>
					<section className='user-bonuses__top'>
						<img
							className='user-bonuses__top-image'
							height='418'
							width='287'
							src={`/files/images/bonuses/level_${level}.jpg`}
							alt=''
						/>
						<div className='user-bonuses__top-content'>
							<div className='user-bonuses__top-contentBox'>
								<p className='user-bonuses__top-title'>Ваши бонусы:</p>
								<div className='user-bonuses__top-count'>
									<span>{priceToUserString(available)}</span>
								</div>
								{!!blocked && (
									<p className='user-bonuses__top-soon'>
										Скоро начислим: {blocked}
										<svg xmlns='http://www.w3.org/2000/svg' width='22' height='15' viewBox='0 0 22 15' fill='none'>
											<path
												d='M0 7.63176V6.80558C0.195293 5.38119 0.798208 4.1898 1.80875 3.2314C5.31529 -0.088367 10.8637 -0.569849 15.1768 0.528532C17.3059 1.0702 19.7005 2.28758 21.0318 4.23129C22.4055 6.23792 22.3207 8.69731 20.7563 10.5931C17.7297 14.259 12.0267 14.9374 7.91435 14.1783C4.79299 13.6024 0.479922 11.6354 0 7.63176ZM18.2146 2.97971C14.0773 0.466978 8.22848 0.420472 4.04256 2.82515C3.9952 2.8525 3.9952 2.87986 4.04256 2.90722C4.27609 3.044 4.41113 3.15753 4.44769 3.24781C4.66792 3.78583 4.88482 4.32658 5.09839 4.87008C5.48981 5.86587 6.20782 6.05189 6.86725 5.18605C7.3185 4.59331 7.76851 3.99876 8.21726 3.40238C8.41422 3.14066 8.59414 2.97424 8.75702 2.90311C9.27434 2.67742 10.0559 2.95372 10.1307 3.64585C10.193 4.22308 10.203 5.46098 10.471 5.9069C10.7241 6.3282 11.3386 6.45814 11.73 6.16132C11.8389 6.07925 11.9494 5.92651 12.0616 5.70309C12.4048 5.01917 12.7452 4.3316 13.0826 3.64038C13.2529 3.29204 13.4262 3.06361 13.6024 2.95509C14.1272 2.63501 14.9549 2.91542 15.0509 3.64585C15.1244 4.21214 15.1768 5.43226 15.4722 5.86997C15.7988 6.35419 16.6826 6.32273 16.9182 5.79474C17.2814 4.98315 17.6429 4.17065 18.0027 3.35724C18.0501 3.24918 18.156 3.14112 18.2258 3.05631C18.2303 3.05062 18.2336 3.04392 18.2355 3.03669C18.2374 3.02947 18.2379 3.02192 18.2368 3.01458C18.2357 3.00723 18.2332 3.00029 18.2293 2.99426C18.2255 2.98823 18.2205 2.98326 18.2146 2.97971ZM4.43024 8.72056C3.81195 7.15711 3.16873 5.60051 2.5841 4.02201C2.56914 3.98098 2.54629 3.97459 2.51554 4.00286C1.12439 5.25718 0.438786 7.36913 1.48714 9.15827C2.09961 10.2015 2.95557 11.0176 4.05503 11.6067C4.08245 11.6213 4.09824 11.6117 4.1024 11.578C4.19215 10.8129 4.3193 10.0551 4.48384 9.30463C4.51875 9.14459 4.49008 8.87376 4.43024 8.72056ZM10.491 12.3207C9.63459 12.7297 9.10979 12.132 9.02129 11.2442C8.89248 9.95026 8.7566 8.65673 8.61367 7.36366C8.55757 6.85482 8.10383 6.87397 7.83457 7.20089C7.40742 7.7234 7.00271 8.26735 6.62043 8.83273C6.50741 8.9996 6.43387 9.18928 6.39979 9.40175C6.28345 10.1176 6.15672 10.8311 6.01959 11.5424C5.95228 11.8926 5.8376 12.1374 5.55712 12.2906C5.54804 12.2959 5.54055 12.3039 5.53558 12.3137C5.53062 12.3236 5.5284 12.3348 5.52919 12.346C5.52999 12.3572 5.53377 12.3679 5.54006 12.3768C5.54636 12.3857 5.55489 12.3924 5.5646 12.396C9.83279 13.9512 15.6218 13.8678 19.3016 10.6273C21.306 8.86419 21.69 6.37471 19.7229 4.23403C19.6914 4.20029 19.666 4.2053 19.6469 4.24907C18.5283 6.72032 17.4143 9.19475 16.3049 11.6724C16.1611 11.9924 16.0053 12.2031 15.8374 12.3043C15.3014 12.6285 14.4039 12.3754 14.2967 11.6478C14.192 10.9301 14.0819 10.2133 13.9664 9.4975C13.8907 9.02422 13.6497 8.74837 13.2434 8.66995C12.7223 8.5701 12.4219 8.88881 12.1813 9.39354C11.7724 10.2516 11.3395 11.0942 10.8824 11.9213C10.7768 12.1128 10.6464 12.246 10.491 12.3207Z'
												fill='#1A1A1A'
												fillOpacity='0.5'
											/>
										</svg>
									</p>
								)}
							</div>
							<img
								className='user-bonuses__top-image _mobile'
								height='418'
								width='287'
								src={`/files/images/bonuses/level_${level}.jpg`}
								alt=''
							/>
							<div className='user-bonuses__top-info'>
								<svg xmlns='http://www.w3.org/2000/svg' width='24' height='16' viewBox='0 0 24 16' fill='none'>
									<path d='M12 12.1953L12 6.69531M12 5.32031L12 3.94531' stroke='black' strokeWidth='1.5' />
									<ellipse cx='12' cy='8.07143' rx='11' ry='7.07143' stroke='black' strokeWidth='1.5' />
								</svg>
								<p className='user-bonuses__top-infoText'>Оплатить бонусами можно до 30% от суммы чека.</p>
							</div>
						</div>
					</section>

					<section className='user-bonuses__level'>
						<h2 className='user-bonuses__level-title user-bonuses__title'>Ваш прогресс:</h2>

						{!isTablet && !isMobile && (
							<ProgressDesktop
								levelOneMax={statusSumm[0]}
								levelSecondMax={statusSumm[1]}
								levelThirdMax={statusSumm[2]}
								activeLevel={level}
								currentSum={totalOrders}
							/>
						)}

						{isTablet && !isMobile && (
							<ProgressTablet
								levelOneMax={statusSumm[0]}
								levelSecondMax={statusSumm[1]}
								levelThirdMax={statusSumm[2]}
								activeLevel={level}
								currentSum={totalOrders}
							/>
						)}

						{isMobile && (
							<ProgressMobile
								levelOneMax={statusSumm[0]}
								levelSecondMax={statusSumm[1]}
								levelThirdMax={statusSumm[2]}
								activeLevel={level}
								currentSum={totalOrders}
							/>
						)}
					</section>

					{!!bonusesHistory.length && (
						<section className='user-bonuses__history'>
							<h2 className='user-bonuses__history-title user-bonuses__title'>История бонусов</h2>

							<div className='user-bonuses__history-wrapper'>
								<div className={`user-bonuses__history-table${collapsed ? ' _collapsed' : ''}`}>
									<div className='user-bonuses__history-head'>
										<div>Дата</div>
										<div>Операция</div>
										<div>Баланс</div>
										<div>
											<span>Дата сгорания</span>
											<span>Сгорание</span>
										</div>
									</div>
									<div className='user-bonuses__history-body'>
										{!!bonusesHistory.length &&
											bonusesHistory.map((bonus, index) => {
												const isActive = bonus.dateTo ? new Date(bonus.dateTo) > Date.now() : true

												return (
													<div
														key={index}
														className={`user-bonuses__history-row${!isActive ? ' _unusable' : ''}${
															bonus.add ? ' _replenishment' : ''
														}${bonus.remove ? ' _debited' : ''}${bonus.pending ? ' _pending' : ''}`}
													>
														<div>
															{new Date(bonus.dateFrom).toLocaleDateString('ru', {
																year: 'numeric',
																month: 'numeric',
																day: 'numeric',
															})}
														</div>
														<div>{bonus.text}</div>
														<div>
															{bonus.add && <>+ {bonus.add}</>}
															{bonus.remove && <>- {-1 * bonus.remove}</>}
															{bonus.pending && (
																<svg
																	xmlns='http://www.w3.org/2000/svg'
																	width='14'
																	height='14'
																	viewBox='0 0 14 14'
																	fill='none'
																>
																	<path
																		d='M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17651 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.6859 5.49207 12.0862 4.04636 11.0199 2.98009C9.95364 1.91382 8.50793 1.31409 7 1.3125ZM7 11.8125C6.04818 11.8125 5.11773 11.5303 4.32632 11.0014C3.53491 10.4726 2.91808 9.72103 2.55383 8.84166C2.18959 7.96229 2.09428 6.99466 2.27997 6.06113C2.46566 5.12759 2.92401 4.27009 3.59705 3.59705C4.27009 2.92401 5.1276 2.46566 6.06113 2.27997C6.99466 2.09428 7.9623 2.18958 8.84167 2.55383C9.72104 2.91808 10.4726 3.53491 11.0014 4.32632C11.5303 5.11773 11.8125 6.04818 11.8125 7C11.8111 8.27591 11.3036 9.49915 10.4014 10.4014C9.49915 11.3036 8.27591 11.8111 7 11.8125ZM10.5 7C10.5 7.11603 10.4539 7.22731 10.3719 7.30936C10.2898 7.39141 10.1785 7.4375 10.0625 7.4375H7C6.88397 7.4375 6.77269 7.39141 6.69064 7.30936C6.6086 7.22731 6.5625 7.11603 6.5625 7V3.9375C6.5625 3.82147 6.6086 3.71019 6.69064 3.62814C6.77269 3.54609 6.88397 3.5 7 3.5C7.11603 3.5 7.22731 3.54609 7.30936 3.62814C7.39141 3.71019 7.4375 3.82147 7.4375 3.9375V6.5625H10.0625C10.1785 6.5625 10.2898 6.60859 10.3719 6.69064C10.4539 6.77269 10.5 6.88397 10.5 7Z'
																		fill='#757575'
																	/>
																</svg>
															)}
														</div>
														<div>
															{!!bonus.remove || !bonus.dateTo ? (
																<>—</>
															) : (
																<>
																	{!isActive ? 'Сгорели ' : ''}
																	{new Date(bonus.dateTo).toLocaleDateString('ru', {
																		year: 'numeric',
																		month: 'numeric',
																		day: 'numeric',
																	})}
																</>
															)}
														</div>
													</div>
												)
											})}
									</div>
								</div>
								{history.length > 4 && !collapsed && (
									<button onClick={handleHistoryMoreClick} className='user-bonuses__history-button'>
										Показать больше
									</button>
								)}
							</div>
						</section>
					)}
				</div>
			)}
		</>
	)
}

export { UserBonuses }
